<template>
  <div id="app">
    <router-view></router-view>
    <bottom-pass v-if="$route.path !='/login'"></bottom-pass>
    <supension v-if="$route.path !='/login'"></supension>
  </div>
</template>

<script>
import supension from '../src/components/suspension.vue'
export default {
  components: { supension },
  name: 'app',
  created () {
    window.addEventListener(
      "mousewheel",
      function (event) {
        console.log(event)
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    //firefox
    window.addEventListener(
      "DOMMouseScroll",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  }
}
</script>

<style>
.font12 {
  font-size: 12px;
}
.font14 {
  font-size: 14px;
}
.font16 {
  font-size: 16px;
}
.font18 {
  font-size: 18px;
}
.font20 {
  font-size: 20px;
}
.font22 {
  font-size: 22px;
}
.font24 {
  font-size: 24px;
}
.font32 {
  font-size: 32px;
}
.font34 {
  font-size: 34px;
}
.font36 {
  font-size: 36px;
}
.font38 {
  font-size: 38px;
}
.font40 {
  font-size: 40px;
}
img {
  display: block;
}
.is-active {
  border: none !important;
  font-weight: 600 !important;
  position: relative !important;
  /* padding-bottom: 20px !important; */
}
.el-image {
  display: block !important;
}
.el-button--primary {
  border-color: #de1f26 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #de1f26 !important;
  border-color: #de1f26 !important;
}
.el-checkbox__label {
  color: #de1f26 !important;
}
.el-tabs__item.is-active {
  color: #de1f26 !important;
}
.el-tabs__active-bar {
  background-color: #de1f26 !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  font-size: 20px !important;
}
.mainBgColor {
  background-color: #de1f26;
}
.mainColor {
  color: #de1f26;
}
body {
  margin: 0px;
  background: #f5f5f5;
  font-family: Microsoft YaHei;
  zoom: 1;
}
.currency_boxs {
  width: 1200px;
  margin: 0 auto;
}
.currency_box {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
}
* {
  margin: 0;
  padding: 0;
}

ul,
li,
ol {
  list-style: none;
}

#app {
  padding: 0;
  margin: 0;
}

img {
  padding: 0;
  margin: 0;
  display: block;
}

/* element组件部分样式强改 */
.el-button--danger {
  background-color: #de1f26 !important;
  border-color: #de1f26 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #de1f26 !important;
}
/* .el-input__inner {
  border: 1px solid #de1f26;
} */
/* .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ffae31;
  border-color: #ffae31;
}
.el-checkbox__inner:hover {
  border-color: #ffae31;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}

.el-button {
  background: #ffae31 !important;
  color: #fff !important;
}
.el-tabs__item.is-active {
  color: #ffae31 !important;
}
.el-tabs__item.is-active:hover {
  color: #ffae31 !important;
}
.el-tabs__active-bar {
  background-color: #ffae31 !important;
}
.el-carousel__button {
  background-color: #000 !important;
} */
.flexEnd {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.flexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flexStart {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.line {
  height: 10px;
  width: 100%;
  background-color: #eee;
}
</style>
